export const APP = {
  ROUTES: {
    ROOT: '/',
    LOGIN: '/login',
    RESET_PASSWORD: '/reset-password',
    FORGET_PASSWORD: '/forget-password',
    AUTHENTICATED: '/authenticated',
    REGISTER: '/register',
  },
};
